import React from "react";
import { TableBody } from "../../UI/TableBody";
import { UserRemoveResultsTableBodyRow } from "./UserRemoveResultsTableBodyRow";

interface IProps {
  users: Record<string, any>[];
  onSuccess: (id: string) => VoidFunction;
}

export const UserRemoveResultsTableBody: React.FC<IProps> = (props) => (
  <TableBody>
    {props.users.map((user) => (
      <UserRemoveResultsTableBodyRow
        user={user}
        key={user.id}
        onSuccess={props.onSuccess(user.id)}
      />
    ))}
  </TableBody>
);

